import * as Dialog from '@radix-ui/react-dialog'
import { useEffect } from 'react'
import Button from '../../../core/Button/Button'
import { Box, Column } from '../../../core/Components'
import { StyledCanvas, useConfetti } from '../../../core/Confetti'
import CopyTextButton from '../../../core/CopyTextButton'
import { Graphics, topGraphics } from '../../../core/Graphics'
import { Subtitle } from '../../../core/Subtitle'
import { Title } from '../../../core/Title'
import { FooterContainer } from './MintSoundModalContent'

export const MintSuccess = ({
  onClickNavigateToSound,
  soundPath
}: {
  onClickNavigateToSound: () => void
  soundPath: string
}) => {
  const { getInstance, fireConfetti } = useConfetti()

  useEffect(() => {
    fireConfetti()
  }, [])

  return (
    <Column css={{ width: '500px' }}>
      <Box css={{ padding: '10px' }}>
        <Graphics className={topGraphics()} />
        <Title>Congratulations!</Title>
        <Subtitle>
          Your sound is currently being minted and will be available in the studio shortly. Anyone
          can use your sound to create songs on Arpeggi. You can view all your samples at the link
          below.
        </Subtitle>
        <Box css={{ marginBottom: '16px ' }}>
          <CopyTextButton link={window.location.origin + soundPath} />
        </Box>
        <FooterContainer css={{ justifyContent: 'end' }}>
          <Dialog.Close asChild>
            <Button type={'dark'} onClick={onClickNavigateToSound} modalButton>
              Check mint status
            </Button>
          </Dialog.Close>
        </FooterContainer>
      </Box>
      <StyledCanvas refConfetti={getInstance} />
    </Column>
  )
}
